<template>
    <div>
        <!-- Yandex.Metrika counter -->
        <img :src="'https://mc.yandex.ru/watch/' + counterID" style="position:absolute; left:-9999px;" alt=""/>
        <!-- /Yandex.Metrika counter -->
    </div>
</template>

<script>
    const counterID = import.meta.env.VITE_YANDEX_METRIKA_COUNTER_ID;

    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments)
        };
        var z = null;
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) {
                return;
            }
        }
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
    })
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(counterID, "init", {
        defer: true,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true
    });

    export default {
        name: "YandexMetrika",
        data() {
            return {
                counterID: counterID,
            };
        },
        mounted() {
            ym(import.meta.env.VITE_YANDEX_METRIKA_COUNTER_ID, "hit", window.location.href);
        }
    }
</script>

<style scoped>

</style>
